import React, { useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CardDrugLibrary from './CardDrugLibrary';
import CardDiseaseLibrary from './CardDiseaseLibrary';
import LLMDiagnose from './LLMDiagnose';

export default function ThreeFlows() {
  const [videoOpen, setVideoOpen] = useState(false);

  return (
    <>
      <Alert
        severity="success"
        sx={{
          mx: 3,
          mt: 2,
          alignItems: 'center',
          '& .MuiAlert-action': { pt: 0 },
        }}
        action={
          <Button
            color="primary"
            variant="contained"
            sx={{ whiteSpace: 'nowrap' }}
            onClick={() => setVideoOpen(true)}
          >
            Watch intro video
          </Button>
        }
      >
        You now also have access to <strong>GekkoVet Copilot</strong> — your
        AI-powered second opinion for veterinarians. Log in with the same
        credentials and subscription at{' '}
        <a href="https://copilot.gekkovet.com" target="_blank" rel="noreferrer">
          copilot.gekkovet.com
        </a>
        .
      </Alert>

      <Grid container spacing={2} padding={3} alignItems={'stretch'}>
        <Grid item md={12} lg={8} sm={12} display={'flex'}>
          <LLMDiagnose style={{ height: '100%', width: '100%' }} />
        </Grid>
        <Grid item container md={12} lg={4} sm={12} spacing={2} display="flex">
          <Grid item xs={12} md={6} lg={12}>
            <CardDiseaseLibrary />
          </Grid>
          <Grid item xs={12} md={6} lg={12}>
            <CardDrugLibrary />
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        open={videoOpen}
        onClose={() => setVideoOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ pr: 6 }}>
          GekkoVet Copilot — Your AI-powered second opinion
          <IconButton
            onClick={() => setVideoOpen(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div style={{ position: 'relative', paddingTop: '56.25%' }}>
            <iframe
              src="https://www.youtube.com/embed/tAq6TFAxpYQ"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="GekkoVet Copilot intro video"
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
